import moment from "moment"
import React, { useEffect, useState } from "react"
import { Button, CardBody, Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row, Table } from "reactstrap"
import PageBody from "../../../components/PageBody"
import IconEdit from '../../../assets/images/icon-edit.png'
import Select from 'react-select'
import { useHistory } from "react-router"
import ModalPopup from "../../../components/ModalPopup"
import CustomerAdd from "../../customer/CustomerAdd"
import styled from "styled-components"
import PriceUtils from "../../../helpers/PriceUtils"
import NumberFormat from 'react-number-format';
import TextUtils from "../../../helpers/TextUtils"
import Loader from "../../../components/Loader"
import IconRight from '../../../assets/images/ic_right-gray.svg';
import IconPayment from '../../../assets/images/ic_paymenttype.svg';
import { cloneDeep, isEmpty } from "lodash"
import { toast } from "react-toastify"
import IconPlus from '../../../assets/images/icon-plus.png';
import RowEmpty from "../../../components/RowEmpty"
import { baseUrl } from "../../../constants/environment"
import APIClient from "../../../helpers/APIClient"
import RowLoading from "../../../components/RowLoading"
import ToggleButton from "../../../common/ToggleButton"


const VNPayTerminal = (props:any) => {
    const {} = props
    const router = useHistory()
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState<any>({});

    useEffect(() => {
        loadData()
    }, []);

    const loadData = async () => {
        setLoading(true);
        const formData = {
            page: 1,
            limit: 1000,
        }
        const url = `${baseUrl}/vnpay-terminal`;
        let response: any = await APIClient.GET(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response.response?.data !== undefined) {
            setData(response?.response?.data)
            setTotalElements(response?.response?.total)
        }
    }

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }
    
    return (
        <>
        <PageBody>
            <div className="mb-3" style={{display: 'flex', justifyContent: 'space-between', alignItems:'center'}}>
                <div className="nutri-title">Danh sách máy POS</div>
                <Button color="success" className="ml-2" onClick={()=>handleActionModal({type: 'add', data:{ name:'', status: 1}})}>
                    <img className='mr-1' style={{border: 'none'}} src={IconPlus} width={20} height={20} alt=""/>  
                    Thêm
                </Button>
            </div>
            <DataTableList
                user={props?.user}
                data={data} loading={loading}
                history={props.history}
                handleActionModal={(data: any) => handleActionModal(data)}
            />
        </PageBody>
        <ModalPopup
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
        >
            <RenderActionModal {...props} closeModal={() => setIsOpen(false)} loadData={()=>loadData()} action={action} />
        </ModalPopup>
        </>
    )
}

const DataTableList = (props: any) => {
    const { data, loading} = props
    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th style={{ width: '15% '}}>Tên máy</th>
                    <th style={{ width: '18%' }}>Terminal code</th>
                    <th style={{ width: '18%' }}>Merchant code</th>
                    <th style={{ width: 200 }}>Cơ sở/kho áp dụng</th>
                    <th style={{ width: 100 }}>Trạng thái</th>
                    <th style={{ width: 100 }}>Thao tác</th>
                </tr>
            </thead>
        )
    }
    const RenderBobyData = () => {
        if (loading) {
            return <RowLoading column={6} row={data.length || 5} />
        }
        if (data.length === 0) {
            return <RowEmpty column={6} title="Chưa có máy POS nào!" />;
        }
        const gotoDetail = (item:any) => {
            props?.handleActionModal({type: 'view', data: item})
        }

        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => (
                    <tr key={`${item?.id}-${index}`}>
                        <td onClick={() => gotoDetail({...item, branch_id: item?.branch_id?.id})}>{item?.name}</td>
                        <td onClick={() => gotoDetail({...item, branch_id: item?.branch_id?.id})}>{item?.terminal_code}</td>
                        <td onClick={() => gotoDetail({...item, branch_id: item?.branch_id?.id})}>{item?.merchant_code}</td>
                        <td onClick={() => gotoDetail({...item, branch_id: item?.branch_id?.id})}>{item?.branch_id?.name}</td>
                        <td onClick={() => gotoDetail({...item, branch_id: item?.branch_id?.id})}>
                            <div style={{marginTop:10}}>
                                <ToggleButton isDisabled={true} elmChecked={item?.status == 1 ? true : false} name='status' />
                            </div> 
                        </td>
                        <td>
                            <div className="table-action">
                                <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'edit', data: {...item, branch_id: item?.branch_id?.id}})}>
                                    <img style={{border: 'none'}} src={IconEdit} width={20} height={20} alt=""/>
                                </div>
                                <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'delete', data: {...item, branch_id: item?.branch_id?.id}})}>
                                    <i className='uil-trash-alt'></i>
                                </div>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        )
    }

    return (
        <div>
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
        </div>
    );
};

const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const [branch, setbranch] = useState<any>([]);
    const [detail, setDetail] = useState(props?.action?.data);
    const { closeModal, action, loadData } = props
    const onlyView = action?.type === 'view'

    useEffect(()=>{
        console.log("RenderActionModal", props?.action?.data)
        setDetail(props?.action?.data)
        loadInit()
    },[props?.action])

    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 100,
        }
        const [
            responseBranch
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/branch`, {
                ...params,
            })
        ]);
        if (responseBranch.response?.data !== undefined) {
            let ListArr:any = [];
            responseBranch.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setbranch(ListArr)
        }
    }

    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        setDetail({
            ...detail,
            [name]: value
        })
    }

    const validationFrom = () => {

        if (isEmpty(detail.name)) {
            toast.warning('Tên máy POS không được để trống!');
            return false
        }
        if (isEmpty(detail.merchant_code)) {
            toast.warning('Merchant code không được để trống!');
            return false
        }
        if (isEmpty(detail.terminal_code)) {
            toast.warning('Terminal code không được để trống!');
            return false
        }
        if (!(detail.branch_id)) {
            toast.warning('Cơ sở không được để trống!');
            return false
        }
        return true
    }

    const handleAdd = async () => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/vnpay-terminal`;
        const params = {
            name: detail?.name,
            terminal_code: detail?.terminal_code,
            merchant_code: detail?.merchant_code,
            branch_id: detail?.branch_id,
            status: detail?.status
        }
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Tạo mới máy POS thành công')
            closeModal()
            loadData()
        }
    };

    const handleEdit = async () => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/vnpay-terminal/${action?.data?.id}`;
        const params = {
            name: detail?.name,
            terminal_code: detail?.terminal_code,
            merchant_code: detail?.merchant_code,
            branch_id: detail?.branch_id,
            status: detail?.status
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Cập nhật máy POS thành công')
            closeModal()
            loadData()
        }
    };

    const handleDelete = async () => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/vnpay-terminal/${action?.data?.id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xóa máy POS thành công')
            closeModal()
            loadData()
        }
    };

    return (
        <CardBody className='p-0' style={{width:action?.type === 'delete' ? 400: 700}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    {action?.type === 'add' && "Tạo máy POS"}
                    {action?.type === 'view' && "Chi tiết máy POS"}
                    {action?.type === 'edit' && "Chỉnh sửa máy POS"}
                    {action?.type === 'delete' && "Xóa máy POS"}
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body p-4">
                {action?.type === 'delete' ?
                <>
                    <div className="text-center">Bạn có chắc chắn muốn xóa máy POS <b className='text-danger'>{action?.data?.name}</b> ?</div>
                </>:
                <PageContent className={onlyView ? 'only-view' : ''}>
                    <FormGroup className="label-only">
                        <Row>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span> Tên máy POS</Label>
                                    <Input type="text" value={detail?.name} onChange={(e: any) => handleChangeInput(e)} name="name" placeholder="Nhập tên máy POS" />
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span> Terminal code</Label>
                                    <Input type="text" value={detail?.terminal_code} onChange={(e: any) => handleChangeInput(e)} name="terminal_code" placeholder="Nhập Terminal code" />
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span> Merchant code</Label>
                                    <Input type="text" value={detail?.merchant_code} onChange={(e: any) => handleChangeInput(e)} name="merchant_code" placeholder="Nhập Merchant code" />
                                </FormGroup>
                            </Col>
                            <Col md={8} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Cơ sở khám</Label>
                                    <Select
                                        placeholder={onlyView && !detail?.branch_id ? '---': "Chọn cơ sở" }
                                        className="react-select mb-2"
                                        classNamePrefix="react-select"
                                        isDisabled={onlyView}
                                        onChange={(val: any) => {
                                            setDetail({ ...detail, branch_id: val?.value })
                                        }}
                                        value={branch?.filter(
                                            (option: any) => detail?.branch_id == option.value
                                        )}
                                        options={branch}
                                        menuPlacement="top"
                                        styles={customStyles}
                                    ></Select>
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Trạng thái</Label>
                                    <div style={{marginTop:10}}>
                                        <ToggleButton isDisabled={onlyView} elmChecked={detail?.status == 1 ? true : false} data={detail} setData={(data:any) => setDetail(data)} name='status' />
                                    </div> 
                                </FormGroup>
                            </Col>
                        </Row>
                    </FormGroup>
                </PageContent>
                }
            </div>
            {action?.type !== 'view' &&
            <div className="modal-footer">
                <Button onClick={closeModal} className="ml-2 success-bland" color="success" type="button"> Hủy bỏ</Button>
                <Button
                    onClick={()=>{
                        action?.type === 'add' && handleAdd()
                        action?.type === 'edit' && handleEdit()
                        action?.type === 'delete' && handleDelete()
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>}
            {loading && <Loader />}
        </CardBody>
    )
}

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`
const customStyles = {
    menuList: (base:any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
      }),
};
export default VNPayTerminal